import * as React from 'react';
import { LoaderProps } from '../../components/loader';

const LoaderView: React.StatelessComponent<LoaderProps> = props => {
    return (
        <div className="ace-cal-loading-container">
            <div className="ace-cal-loading">
                <p className="visually-hidden">
                    {props.isLoading ? props.text.loaderIsLoadingText : props.text.loaderHasLoadedText}
                </p>
                <div className="ace-cal-loader-container" role="presentation">
                    <div className="ace-cal-loader"></div>
                </div>
            </div>
        </div>
    )
}

export default LoaderView;